import { Hooks } from 'interface/sharedJsInterface.js';

import * as Assignment from 'app/hooks/assignment.js';
import * as Cart from 'app/hooks/cart.js';
import * as ExamTemplate from 'app/hooks/examTemplate.js';
import * as Helpers from 'app/hooks/helpers.js';
import * as Keypress from 'app/hooks/keypress.js';
import useNavigation from 'app/hooks/navigation.js';
import * as OrganizationUsersSubscription from 'app/hooks/organizationUsersSubscriptions.jsx';
import * as QuizNavigation from 'app/hooks/quizNavigation.jsx';
import * as QuizResponse from 'app/hooks/quizResponse.js';
import * as Redirects from 'app/hooks/redirects.js';
import * as UsageReports from 'app/hooks/usageReports.js';
import * as UserManagement from 'app/hooks/userManagement.js';
import * as CartLoggerEnabled from 'app/hooks/cartLoggerEnabled.js';


const {
  B2b,
  ClinicalPearls,
  Cme,
  Highlight,
  Loading,
  Performance,
  QuestionsFilter,
  RiskAssessment,
  StaticData,
  TakingQuiz,
  Users,
  BoardExamDates,
  Lti,
  Organizations,
  Params,
  Products,
  Quiz,
  React,
  Subscriptions,
} = Hooks;

const Navigation = {
  useNavigation
};

export {
  Assignment,
  Cart,
  CartLoggerEnabled,
  ExamTemplate,
  Helpers,
  Keypress,
  Navigation,
  OrganizationUsersSubscription,
  QuizNavigation,
  QuizResponse,
  Redirects,
  UserManagement,
  UsageReports,
  B2b,
  ClinicalPearls,
  Cme,
  Highlight,
  Loading,
  Performance,
  QuestionsFilter,
  RiskAssessment,
  StaticData,
  TakingQuiz,
  Users,
  BoardExamDates,
  Lti,
  Organizations,
  Params,
  Products,
  Quiz,
  React,
  Subscriptions,
};
